module.exports = __webpack_public_path__ + "img/icon-call_duration.0479ef71.svg";